module.exports = __webpack_public_path__ + "img/655.c766a296.png";